import { l } from 'client/Other/Translation'

export enum EInvoicingScheme {
  VAT = 'VAT',
  ORGNR = 'ORGNR',
  GLN = 'GLN',
  DUNS = 'DUNS',
  IBAN = 'IBAN',
  OVT = 'OVT',
  LWID = 'LWID',
  CUSTOM = 'CUSTOM',
}

export enum NetworkType {
  PEPPOL = 'PEPPOL',
  PRIVATE = 'PRIVATE',
}

export const UNKNOWN_VALUE = 'UNKNOWN'

export interface EInvoiceAddressInterface {
  networkType?: string
  scheme?: EInvoicingScheme
  address?: string
  networkOperatorId?: string
}

export const getSchemeMap = (addressTypes) => {
  return addressTypes.reduce((result, addressType) => {
    return { ...result, [addressType]: l('scheme.' + addressType) }
  }, {})
}

export const getDefaultScheme = (addressTypes, country) => {
  const addressTypesCountry = addressTypes ? addressTypes[country] || addressTypes.INT : null
  return addressTypesCountry ? addressTypesCountry[0] : EInvoicingScheme.CUSTOM
}
